'use client';

import { useEffect, useState } from 'react';
import { useSearchParams } from 'next/navigation';
import { Paper, Tabs } from '@mantine/core';
import { TabBeranda } from './TabBeranda';
import { TabLayanan } from './TabLayanan';
import { TabProduk } from './TabProduk';

export function OutletTabs() {
  const [activeTab, setActiveTab] = useState<string | null>('beranda');
  const searchParams = useSearchParams();
  const params = {
    search: searchParams.get('search'),
  };

  useEffect(() => {
    if (params.search) {
      setActiveTab('produk');
    }
  }, [params.search]);

  return (
    <Tabs
      defaultValue="beranda"
      value={activeTab}
      onChange={setActiveTab}
      radius={0}
    >
      <Paper radius="0">
        <Tabs.List mb="md" grow justify="center">
          <Tabs.Tab value="beranda">Beranda</Tabs.Tab>
          <Tabs.Tab value="produk">Produk</Tabs.Tab>
          <Tabs.Tab value="layanan">Layanan</Tabs.Tab>
          {/* <Tabs.Tab value="produk">
                        Produk
                    </Tabs.Tab>
                    <Tabs.Tab value="kategori">
                        Kategori
                    </Tabs.Tab> */}
        </Tabs.List>
      </Paper>

      <Tabs.Panel value="beranda">
        <TabBeranda
          goToProduk={() => setActiveTab('produk')}
          goToLayanan={() => setActiveTab('layanan')}
        />
      </Tabs.Panel>

      <Tabs.Panel value="produk">
        <TabProduk />
      </Tabs.Panel>

      <Tabs.Panel value="layanan">
        <TabLayanan />
      </Tabs.Panel>

      {/* <Tabs.Panel value="produk">
                <TabProduk />
            </Tabs.Panel>

            <Tabs.Panel value="kategori">
                <TabKategori />
            </Tabs.Panel> */}
    </Tabs>
  );
}
